var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarrel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.447715 0.447715 0 1 0H32C32.5523 0 33 0.447715 33 1V5.5C33 5.81476 32.8518 6.11115 32.6 6.3L32.0667 6.7C31.5333 7.1 31.5333 7.9 32.0667 8.3L32.6 8.7C32.8518 8.88885 33 9.18524 33 9.5V11C33 11.5523 32.5523 12 32 12H0.999999C0.447714 12 0 11.5523 0 11V9.5C0 9.18524 0.148194 8.88885 0.4 8.7L0.933333 8.3C1.46667 7.9 1.46667 7.1 0.933333 6.7L0.4 6.3C0.148194 6.11115 0 5.81476 0 5.5V1Z",
    fill: "#9B9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 49C33 49.5523 32.5523 50 32 50L0.999999 50C0.447714 50 3.91405e-08 49.5523 8.74228e-08 49L4.80825e-07 44.5C5.08342e-07 44.1852 0.148195 43.8889 0.400001 43.7L0.933334 43.3C1.46667 42.9 1.46667 42.1 0.933334 41.7L0.400001 41.3C0.148195 41.1111 8.02999e-07 40.8148 8.30516e-07 40.5L3.32207e-06 12C3.37035e-06 11.4477 0.447719 11 1 11L32 11C32.5523 11 33 11.4477 33 12L33 40.5C33 40.8148 32.8518 41.1111 32.6 41.3L32.0667 41.7C31.5333 42.1 31.5333 42.9 32.0667 43.3L32.6 43.7C32.8518 43.8889 33 44.1852 33 44.5L33 49Z",
    fill: "#9B9B9B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 6,
    height: 2,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 2,
    width: 7,
    height: 2,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 2,
    width: 6,
    height: 2,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 46,
    width: 6,
    height: 2,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 46,
    width: 7,
    height: 2,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 46,
    width: 6,
    height: 2,
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 12.5,
    x2: 33,
    y2: 12.5,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 24.5,
    x2: 33,
    y2: 24.5,
    stroke: "black"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 36.5,
    x2: 33,
    y2: 36.5,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarrel);
export default __webpack_public_path__ + "static/media/barrel.5537947ed4eb36bcb5d92a64fc1b539a.svg";
export { ForwardRef as ReactComponent };